import { Controller } from 'front-end-core/core/Router'
import Main from 'pages/utils/Main'
import Header from 'pages/utils/Header'
import { UTILS } from 'constants/controllers'

export default new Controller({
  name: UTILS,
  route: '(:aol/)utils(/:view)',
  controller (
    Router,
    {
      url,
      params: { aol, view }
    },
    render
  ) {
    render(
      { Main, Header },
      { aol, view: view || 'icons' },
      { aol }
    )

    return url
  }
})
